/* eslint-disable @typescript-eslint/naming-convention */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BASEURL: '',
  BASEURLAPI: '/webapi2',
  WEBCLIENTURL: '/webclient',
  AUTHENTICATIONURL: '/api/account/authenticate',
  FORGOTPASSWORD: '/api/account/forgotpassword',
  FORGOTMOBILEUSERPASSWORD: '/api/account/forgotmobileuserpassword',
  RESETMOBILEUSERPASSWORD: '/api/account/forgotmobileuserpasswordcomplete',
  RESETPASSWORD: '/api/Account/forgotpasswordcomplete',
  FORMSURL: '/api/forms',
  JOBSSEARCHURL: '/api/jobs/search',
  JOBSAVEURL: '/api/jobs',
  JOBTYPESURL: '/api/jobtypes',
  MOBILEUSERSURL: '/api/mobileusers',
  USERSURL: '/api/users',
  SSRSPROXYURL: 'ssrsproxy',  
  JOBTYPEURL: '/api/jobtypes/', //append id to the url
  MENUSURL: '/api/Menus/CurrentUser',
  VIEWSURL: '/api/FilteredView/CurrentUser',
  FILTEREDVIEWURL: '/api/FilteredView/',
  FORMRECORDURL: 'CompletedRecords/search',
  COMPLETEDRECORDURL: 'CompletedRecords',
  REPORTSURL: '/api/reports/',
  REPORTSURLFORFORM: 'reports/',
  NOTIFICATIONHISTORYURL: '/api/NotificationHistory/search',
  NOTIFICATIONHISTORYRESENDURL: '/api/NotificationHistory/Resend',
  NOTIFICATIONHISTORYRESENDBULKURL: '/api/NotificationHistory/ResendBulk',
  NOTIFICATIONHISTORYDELETEURL: '/api/NotificationHistory/Delete',
  NOTIFICATIONURL: '/api/notifications',
  USERGROUPSURL: '/api/UserGroups',
  CHANGEPASSWORDURL: '/api/account/changepassword',
  DATAEDITORURL: '/secure/EditFormData.aspx?FormId=',
  BASE_NOMINATIM_URL: 'https://openstreetmap.esayworkmobile.co.uk',
  DEFAULT_VIEW_BOX: 'viewbox=7.715842912499982%2C58.4041727851977%2C-14.168922712499997%2C50.7950163114598',
  PAGESIZE: 50,
  PAGESIZEOPTIONS: [50, 100, 500],
  RESOURCEURL: '/api/Resources/DataLinkSource',
  DOWNLOADURL: '/api/Resources/DownloadDataLinkSource',
  RESOURCESURL: '/api/Resources',
  UPLOADURL: '/api/Resources/UploadDataLinkSource',
  COLLAGEURL: '/api/MediaAttachments/Collage',
  CATALOGUEUNIQUECOLUMNURL: '/api/catalogues/uniquecolumn',
  CATALOGUEURL: '/api/catalogues',
  CATALOGUEDETAILSBYUSERFORMID: '/api/catalogues/retrievecataloguebyuserformid',
  CATALOGUEDETAILSBYCATALOGUEID: '/api/catalogues/retrievecataloguebycatalogueid',
  UPLOADCATALOGUE: '/api/catalogues/uploadcatalogfile',
  CRMCUSTOMERSURL: '/api/crm/customers',
  CRMCONTACTSURL: '/api/crm/contacts',
  REVISIONHISTORYIFRAMEURL: '/secure/ViewFormRevisions.aspx',
  ACCOUNTVERIFICATION: '/api/account/VerifyAccountRegistration',
  APPROVALURL: '/api/approvals/getinboxtotals',
  LONEWORKERURL: '/api/loneworker',
  TRACKWORKERURL: '/api/trackworker',
  AUTORELOADINTERVAL: 120,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
